import {
  AUTH_USER, UNAUTH_USER, AUTH_ERROR, FETCH_MESSAGE, ERROR, FETCH_USER_PROFILE
} from '../actions/types';

const initState = { authenticated: false, error: '', user: {} };

export default function authReducer(state=initState, action) {
  switch (action.type) {
    case AUTH_USER:
      return { authenticated: true, error: '', user: action.payload };
    case FETCH_USER_PROFILE:
      return { ...state,
        user: { ...state.user,
          ...action.payload
        }
      };
    case UNAUTH_USER:
      return initState;
    case AUTH_ERROR:
      return { authenticated: false, error: action.payload, user: {} };
    case FETCH_MESSAGE:
      return { ...state, message: action.payload };
    case ERROR:
      return { ...state, error: action.err };
    default:
      return state;
  }
}





















/* END */



// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js